import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux'
import { ButtonGroup, Button } from 'reactstrap';
import { Link } from "react-router-dom";
import WorkflowForm from '../WorkflowForm/WorkflowForm';
import PageTitle from '../../../components/PageTitle/PageTitle';
import { Utils } from '../../../services';
import { loadWorkflow, updateWorkflow } from '../../../redux/modules/workflows';

const WorkflowEdit = ({ match }) => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        const { workflowId } = match.params;
        dispatch(loadWorkflow(workflowId));
    }, [dispatch])

    const submit = (values) => {
        dispatch(updateWorkflow(values));
    }

    const { workflow } = useSelector(state => state.workflows);

    let title = <span>{t('workflows.update_workflow')}</span>;

    if (workflow && workflow.name)
        title = (
            <span>
                {t('workflows.workflow', {count: 1})}
                <small> |&nbsp;{ t('workflows.update_workflow', { name: workflow.name[Utils.default_lang()] })} </small>
            </span>
        );

    const actions =
        <div>
            {workflow &&
            <ButtonGroup>
                <Button  tag={Link} to="/workflows" color="warning" size="sm">
                    <i className="fa fa-arrow-left"></i>&nbsp;{t('common.back')}
                </Button>
            </ButtonGroup>
            }
        </div>

        return (
            <div className="WorkflowEdit">
                <PageTitle icon="code-fork" title={ title } actions={ actions } />

                {workflow &&
                    <WorkflowForm workflowId={workflow._id} onSubmit={ submit } />
                }
            </div>
        );
}

export default WorkflowEdit;
